import {
  ReportingMelcoMachineStatisticsModelsViewListItem,
  useAPIQuery,
  useTable,
  ViewsApi,
} from "melco-shared-logic";
import isEmpty from "lodash-es/isEmpty";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useStatus = () => {
  const {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    currentPage,
    pageSize,
    sortBy,
    searchQuery,
    searchQueryChange,
  } = useTable<ReportingMelcoMachineStatisticsModelsViewListItem>();

  const query = useAPIQuery(
    ViewsApi,
    ["MachineStatus", currentPage, pageSize, filters, sortBy(), searchQuery],
    async (api: ViewsApi) => {
      const response = await api.statisticalViewSearch({
        offset: (currentPage - 1) * pageSize,
        limit: pageSize,
        sortBy: sortBy(),
        searchText: !isEmpty(searchQuery) ? searchQuery : undefined,
      });

      setTotal(response.total);

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: false,
      },
    }
  );

  const errorComponent = useTableErrorComponent(query.error, query.refetch);

  return {
    onTableConfigChange,
    pagination,
    setTotal,
    filters,
    sorter,
    searchQuery,
    searchQueryChange,
    errorComponent,

    ...query,
  };
};
